import { Injectable } from '@angular/core';
import { HttpClient } from '../../../../node_modules/@angular/common/http';
import { Auth } from '../../shared/auth';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {
  }

  /**
   * get services from api
   *
   */
  public get() {
    return this.http.get('users?api_token=' + Auth.getApiToken());
  }

  /**
   * store new service
   */
  public store(data: any) {
    return this.http.post('users/store' + '?api_token=' + Auth.getApiToken(), data);
  }
  public resultaccess(data: any) {
    return this.http.post('users/result/access' + '?api_token=' + Auth.getApiToken(), data);
  }
  /**
   * update service
   */
  public update(id, data: any) {
    return this.http.post('users/update/' + id + '?api_token=' + Auth.getApiToken(), data);
  }

  /**
   * remove service
   */
  public destroy(id) {
    return this.http.post('users/delete/' + id + '?api_token=' + Auth.getApiToken(), null);
  }
}
